import React from "react";
// node.js library that concatenates classes (strings)
// javascipt plugin for creating charts
import Chart from "chart.js";
// react plugin used to create charts
// core components
import {chartOptions, parseOptions} from "variables/charts.js";
import {Redirect} from "react-router-dom";
import localeHelpers from "../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {common_strings} from "../translations/common_translations";
import {student_strings} from "../translations/student_translations";
import {resource_strings} from "../translations/resource_translations";
import {alert_strings} from "../translations/alert_translations";
import {report_strings} from "../translations/report_translations";
import clientHelper from "../helpers/ClientHelper";
import DiscoverHeader from "../components/Headers/DiscoverHeader";

let commonStrings = new LocalizedStrings(common_strings);
let studentStrings = new LocalizedStrings(student_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let alertStrings = new LocalizedStrings(alert_strings);
let reportStrings = new LocalizedStrings(report_strings);

class Teachers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            client: clientHelper.client(),
            showError: false,
            error: null,
        };
        if (window.Chart) {
            parseOptions(Chart, chartOptions());
        }
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    handleNetworkError(e) {
        this.setState({
            isLoading: false,
            error: e,
            showError: true,
            attendance_loading: false,
        });
    }

    componentDidMount() {
        if (!localStorage.getItem('at') || !localStorage.getItem('client')) {
            return <Redirect from="*" to="/auth/login"/>
        } else {
        }
    }

    render() {
        this.localize();

        return (
            <>
                <DiscoverHeader
                />
                {/* Page content */}
            </>
        );
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
    }
}

export default Teachers;
